/*90467_Carga_de_Imagenes_Ecommerce  */
import React from "react";

class ListadoImagenDinamicoEcommerce extends React.Component {
    render() {
        const { props } = this;

        return (
            <div className="card card-plain card-lg">
                <div className="wrapper tableFdv">
                    <div>
                        <div style={{ marginBottom: "15px" }}>
                            <label className="labelInfo" htmlFor="TipoImagenEcommerceFiltro">
                                Tipo de imagen
                                </label>
                            <select
                                id={`p_tipoimgEcommercefiltro_`}
                                name={`p_tipoimgEcommercefiltro`}
                                className="form-control input-sm"
                                onChange={(e) => props.onChangeValueTipoimgEcommerceFiltro(e)}
                                value={props.tipoimgEcommerceFiltro}
                            >
                                <option value="0">Seleccione</option>
                                {props.arretipimag.map((c, i) => (
                                    <option key={i} value={c.codigo}>
                                        {c.descripcion}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div style={{ marginBottom: "15px" }}>
                        <label
                            className="labelInfo"
                            htmlFor="colorVehiculoEcommerceFiltro"
                        >
                            Color Vehiculo
                                                                </label>
                        <select
                            id={`p_colorVehiculoEcommerceFiltro_`}
                            name={`p_colorVehiculoEcommerceFiltro`}
                            className="form-control input-sm	"
                            onChange={(e) =>
                                props.onChangeValueColorVehiculoEcommerceFiltro(e)
                            }
                            value={props.colorVehiculoEcommerceFiltro}
                        >
                            <option value="0">Seleccione</option>
                            {props.listaColorVeh.map((c, i) => (
                                <option key={i} value={c.codPintura}>
                                    {c.color}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button
                        className="btn btn-blue-p"
                        onClick={props.filtrarIMG}
                        style={{ width: "95px", marginRight: "15px" }}
                    >
                        Filtrar
                        </button>

                    <div align="right">
                        <button
                            className="btn btn-blue-p"
                            onClick={props.agregarParametrosIMGEcommerce}
                            style={{ width: "95px", marginRight: "15px" }}
                        >
                            Agregar
                        </button>
                    </div>
                    <br />
                    <div className="tableWrapper" style={{ border: "1px solid #e5e5e5" }}>
                        <table
                            className="table table-hover"
                            style={{ marginBottom: "100px" }}
                        >
                            <tbody>
                                {props.arreimagenesEcommerceList.length ? (
                                    props.arreimagenesEcommerceList
                                        .sort(function (a, b) {
                                            if (Number(a.numeroOrden) > Number(b.numeroOrden)) {
                                                return 1;
                                            }
                                            if (Number(a.numeroOrden) < Number(b.numeroOrden)) {
                                                return -1;
                                            }
                                            return 0;
                                        })
                                        .map((imagen, index) => (
                                            <tr
                                                key={index}
                                                style={
                                                    imagen.indInactivo === "S"
                                                        ? { display: "none" }
                                                        : { display: "inline-table", width: "100%" }
                                                }
                                            >
                                                <td width="220">
                                                    <div>
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <label className="labelInfo" htmlFor="TipoImagen">
                                                                Tipo de imagen
                                                        </label>
                                                            <select
                                                                id={`p_tipoimgEcommerce_` + index}
                                                                name={`p_tipoimgEcommerce`}
                                                                className="form-control input-sm"
                                                                onChange={(e) => props.onUpdateItem(e, index)}
                                                                defaultValue={imagen.tipoImagen}
                                                                value={imagen.p_tipoimgEcommerce ? imagen.p_tipoimgEcommerce : imagen.tipoImagen}
                                                            >
                                                                <option value="0">Seleccione</option>
                                                                {props.arretipimag.map((c, i) => (
                                                                    <option key={c.codigo} value={c.codigo}>
                                                                        {c.descripcion}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {props.listaColorVeh &&
                                                            props.listaColorVeh.length > 0 ? (
                                                                <div style={{ marginBottom: "15px" }}>
                                                                    <label
                                                                        className="labelInfo"
                                                                        htmlFor="colorVehiculo"
                                                                    >
                                                                        Color Vehiculo
                                                                </label>
                                                                    <select
                                                                        id={`p_colorVehiculoEcommerce_` + index}
                                                                        name={`p_colorVehiculoEcommerce`}
                                                                        className="form-control input-sm	"
                                                                        onChange={(e) =>
                                                                            props.onUpdateItem(e, index)
                                                                        }
                                                                        defaultValue={imagen.colorVehiculo}
                                                                        value={imagen.p_colorVehiculoEcommerce ? imagen.p_colorVehiculoEcommerce : imagen.colorVehiculo}
                                                                    >
                                                                        <option value="0">Seleccione</option>
                                                                        {props.listaColorVeh.map((c, i) => (
                                                                            <option key={c.codPintura} value={c.codPintura}>
                                                                                {c.color}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            ) : (
                                                                <div></div>
                                                            )}

                                                        <div>
                                                            <label className="labelInfo" htmlFor="Alto">
                                                                Alto
                            </label>
                                                            <input
                                                                className="form-control"
                                                                id={`p_altoEcommerce_` + index}
                                                                name={`p_altoEcommerce`}
                                                                type="text"
                                                                onChange={(e) => props.onUpdateItem(e, index)}
                                                                readOnly={true}
                                                                defaultValue={imagen.alto}
                                                                value={imagen.p_altoEcommerce ? imagen.p_altoEcommerce : imagen.alto}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>

                                                <td width="220">
                                                    <div>
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <label className="labelInfo" htmlFor="NroOrden">
                                                                Orden imagen
                            </label>
                                                            <input
                                                                className="form-control"
                                                                id={`p_nroordenEcommerce_` + index}
                                                                name={`p_nroordenEcommerce`}
                                                                type="text"
                                                                type="number"
                                                                step="1"
                                                                min="1"
                                                                max="100"
                                                                required
                                                                onChange={(e) => props.onUpdateItem(e, index)}
                                                                defaultValue={imagen.numeroOrden}
                                                                value={imagen.p_nroordenEcommerce ? imagen.p_nroordenEcommerce : imagen.numeroOrden}
                                                            />
                                                        </div>

                                                        {props.listaColorVeh &&
                                                            props.listaColorVeh.length > 0 &&
                                                            (
                                                                (imagen.p_colorVehiculoEcommerce || imagen.colorVehiculo) &&
                                                                (props.listaColorVeh.find(
                                                                    (obj) =>
                                                                        obj.codPintura === imagen.p_colorVehiculoEcommerce
                                                                ) &&
                                                                    props.listaColorVeh.find(
                                                                        (obj) =>
                                                                            obj.codPintura === imagen.p_colorVehiculoEcommerce
                                                                    )["pinturaTapizList"] &&
                                                                    props.listaColorVeh.find(
                                                                        (obj) =>
                                                                            obj.codPintura === imagen.p_colorVehiculoEcommerce
                                                                    )["pinturaTapizList"].length > 0)

                                                                ||

                                                                (props.listaColorVeh.find(
                                                                    (obj) =>
                                                                        obj.codPintura === imagen.colorVehiculo
                                                                ) &&
                                                                    props.listaColorVeh.find(
                                                                        (obj) =>
                                                                            obj.codPintura === imagen.colorVehiculo
                                                                    )["pinturaTapizList"] &&
                                                                    props.listaColorVeh.find(
                                                                        (obj) =>
                                                                            obj.codPintura === imagen.colorVehiculo
                                                                    )["pinturaTapizList"].length > 0)
                                                            )
                                                            ? (
                                                                <div style={{ marginBottom: "15px" }}>
                                                                    <label className="labelInfo" htmlFor="TipoImagen">
                                                                        Color Tapiz
                                                                </label>
                                                                    <select
                                                                        id={`p_colorVehiculoTapizEcommerce_` + index}
                                                                        name={`p_colorVehiculoTapizEcommerce`}
                                                                        className="form-control input-sm"
                                                                        onChange={(e) => {
                                                                            props.onUpdateItem(e, index);
                                                                        }}
                                                                        defaultValue={imagen.colorVehiculoTapiz}
                                                                        value={imagen.p_colorVehiculoTapizEcommerce ? imagen.p_colorVehiculoTapizEcommerce : imagen.colorVehiculoTapiz}
                                                                    >
                                                                        <option value="0">Seleccione</option>
                                                                        {props.listaColorVeh
                                                                            .find(
                                                                                (obj) =>
                                                                                    obj.codPintura ===
                                                                                    imagen.p_colorVehiculoEcommerce ||
                                                                                    obj.codPintura === imagen.colorVehiculo
                                                                            )
                                                                        ["pinturaTapizList"].map((c, i) => (
                                                                            <option key={c.codColorTapiz} value={c.codColorTapiz}>
                                                                                {c.desColorTapiz}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            ) : (
                                                                <div style={{ marginBottom: "15px" }}>
                                                                    <label className="labelInfo" htmlFor="TipoImagen">
                                                                        Color Tapiz
                                                                </label>
                                                                    <select className="form-control input-sm">
                                                                        <option value="0">Seleccione</option>
                                                                    </select>
                                                                </div>
                                                            )}




                                                        <div>
                                                            <label className="labelInfo" htmlFor="Ancho">
                                                                Ancho
                            </label>
                                                            <input
                                                                className="form-control"
                                                                id={`p_anchoEcommerce_` + index}
                                                                name={`p_anchoEcommerce`}
                                                                type="text"
                                                                onChange={(e) => props.onUpdateItem(e, index)}
                                                                readOnly={true}
                                                                defaultValue={imagen.ancho}
                                                                value={imagen.p_anchoEcommerce ? imagen.p_anchoEcommerce : imagen.ancho}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>

                                                <td width="320">
                                                    <div>
                                                        <div style={{ marginLeft: "40px" }}>
                                                            {imagen.codImagen != "" ? (
                                                                <img
                                                                    width="360"
                                                                    height="120"
                                                                    onChange={(e) => props.onUpdateItem(e, index)}
                                                                    src={imagen.picture}
                                                                    id="img"
                                                                />
                                                            ) : (
                                                                    <img
                                                                        width="360"
                                                                        height="120"
                                                                        alt={props.imageFile}
                                                                        src={props.imageFile}
                                                                        id="imgFile"
                                                                    />
                                                                )}
                                                        </div>

                                                        <div style={{ marginLeft: "145px" }}>
                                                            {imagen.codImagen != "" ? (
                                                                <label></label>
                                                            ) : (
                                                                    <label className="btn btn-blue">
                                                                        <input
                                                                            type="file"
                                                                            id={`p_file_` + index}
                                                                            value={imagen.idFile}
                                                                            style={{ display: "none" }}
                                                                            onChange={(e) =>
                                                                                props.handleOnChange(e, index)
                                                                            }
                                                                        />
                                                                        <i className="fa fa-cloud-upload"></i>
                                Seleccionar Imagen
                                                                    </label>
                                                                )}
                                                        </div>
                                                    </div>
                                                </td>

                                                <td width="80">
                                                    <div className="wrapper">
                                                        <div className="row">
                                                            <button
                                                                className="btn btn-orange-p"
                                                                onClick={() =>
                                                                    props.grabarParametroIMG(
                                                                        index,
                                                                        imagen.codImagen
                                                                    )
                                                                }
                                                                style={{ width: "95px" }}
                                                            >
                                                                Guardar
                            </button>
                                                        </div>
                                                        <div className="row" style={{ marginTop: "10px" }}>
                                                            <button
                                                                className="btn btn-red-p"
                                                                onClick={(e) => {
                                                                    if (
                                                                        window.confirm(
                                                                            "¿ Esta seguro que desea eliminar este registro?"
                                                                        )
                                                                    )
                                                                        props.eliminarParametrosIMG(
                                                                            e,
                                                                            index,
                                                                            imagen.codImagen
                                                                        );
                                                                }}
                                                                style={{ width: "95px" }}
                                                            >
                                                                Eliminar
                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                ) : (
                                        <tr>
                                            <td colSpan={4}>No hay resultados</td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default ListadoImagenDinamicoEcommerce;



// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/ListadoImagenDinamicoEcommerce.js